/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import fetcher from '@/core/lib/fetcher'
import { Package, PackageFormValues } from '../rates/rate.types'
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'

import { APIError, APIResponse } from '@/core/types/utils'
import { toast } from '@/core/components/ui/use-toast'

export const packagesQueryOptions = (siteId: string, token: string) =>
  queryOptions({
    queryKey: ['packages', siteId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(import.meta.env.VITE_API_BOOKING + `property/${siteId}/package`)
        .json<Promise<APIResponse<Package[]>>>(),
  })

export const packageByIdQueryOptions = (siteId: string, packageId: string, token: string) =>
  queryOptions({
    queryKey: ['package', siteId, packageId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(import.meta.env.VITE_API_BOOKING + `property/${siteId}/package/${packageId}`)
        .json<Promise<APIResponse<Package>>>(),
  })

export const updatePackage = (
  data: PackageFormValues,
  packageId: string,
  siteId: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(import.meta.env.VITE_API_BOOKING + `property/${siteId}/package/${packageId}`)
    .put(data)
    .json()

export const createPackage = (
  data: PackageFormValues,
  siteId: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(import.meta.env.VITE_API_BOOKING + `property/${siteId}/package`)
    .post(data)
    .json()

export const useDeletePackage = (token: string, siteId?: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      fetcher
        .auth(`Bearer ${token}`)
        .url(import.meta.env.VITE_API_BOOKING + `property/${siteId}/package/${id}`)
        .delete()
        .json(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['packages'],
      })
    },
    onError: (error) => {
      const errorObject: APIError<null> = JSON.parse(error.message)
      const errorMessage = errorObject.message
      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      })
    },
  })
}
